import React from 'react';
export const UploadRestApiPreview = ({ headers, restApiData }) => {
  return (
    <div className="row">
      <div className="col-md-12 text-center">
        <h2>Imported REST API Content</h2>
      </div>
      <div className="col-md-12 table-responsive csv-preview-table">
        <table className="table table-bordered table-hover table-sm table-word-break">
          <thead>
            <tr>
              {Object.keys(headers).map((key, index) => (
                <th key={key}>{headers[index]}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {restApiData.map((item, index) => (
              <tr key={index}>
                {Object.keys(headers).map((key, index) => (
                  <td key={key}>
                    {typeof item[headers[index]] === 'boolean'
                      ? item[headers[index]].toString()
                      : item[headers[index]]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
